export default __webpack_public_path__ + "static/media/8.7f151b20.png";